export default {
  'importBatch.addendum_id': 'Addendum ID',
  'importBatch.description': 'Message Description',
  'importBatch.recordNumber': 'Record Number',
  'importBatch.type': 'Type',
  'importBatch.receiver': 'Receiver',
  'importBatchCustom.beneficiary': 'Name',
  'importBatchCustom.beneficiaryId': 'ID',
  'importBatchCustom.beneficiaryAccountNumber': 'Account Number',
  'importBatchCustom.beneficiaryBankRoutingNumber': 'Bank Code / Number',
  'importBatchCustom.transactionType': 'Credit/Debit'
};
